jQuery(document).ready(function ($) {
    const offset = 150;

    $('.anchors__list a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        const target = $($(this).attr('href'));

        if (target.length) {
        $('html, body').animate({
            scrollTop: target.offset().top - offset
        }, 100);
        }
    });
});

jQuery(document).ready(function($) {
    var $anchorsNav = $('#anchors');
    var scrollHeight = 500;

    function fixNav() {
        var currentScrollHeight = $(window).scrollTop();
        if (currentScrollHeight >= scrollHeight) {
            $anchorsNav.addClass('fixed');
        } else {
            $anchorsNav.removeClass('fixed');
        }
    }

    $(window).on('scroll', fixNav);
});

jQuery(document).ready(function($) {
    var $mobAnchorsNav = $('#mob-anchors');
    var scrollHeight = 450;

    function fixNav() {
        var currentScrollHeight = $(window).scrollTop();
        if (currentScrollHeight >= scrollHeight) {
            $mobAnchorsNav.addClass('fixed');
        } else {
            $mobAnchorsNav.removeClass('fixed');
        }
    }

    $(window).on('scroll', fixNav);
});

jQuery(document).ready(function() {
    const swiper = new Swiper('.swiper-mob-anchors', {
        slidesPerView: 1,
        centeredSlides: false,    
        grabCursor: true,
        loop: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    swiper.init();
});
